var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/EstimationApi/EstimationRepo/SimpleField.ts";
import * as t from 'io-ts';
export var SimpleField;

(function (_SimpleField) {
  var io = _SimpleField.io = t.type({
    elementPropertyId: t.number
  }, 'SimpleField');
})(SimpleField || (SimpleField = {}));